<div class="dropdown">
    <div class="multi-select-container" (click)="toggleDropdown()">
        <div class="rounded-full-container">
            <span *ngFor="let opt of selectedOptions" class="bg-secondary" title="{{ opt.name }}">
                <span class="rounded-full-label">{{ opt.name }}</span>
                <button type="button" class="btn-close btn-close-white" (click)="removeBadge(opt, $event)"></button>
            </span>
            <span *ngIf="selectedOptions.length === 0" class="text-gray-500">Select...</span>
        </div>
        <i *ngIf="!isOpen" class="bi bi-chevron-down" (click)="toggleDropdown(); $event.stopPropagation()"></i>
        <i *ngIf="isOpen" class="bi bi-chevron-up" (click)="toggleDropdown(); $event.stopPropagation()"></i>
    </div>
    <div *ngIf="isOpen" class="dropdown-menu show">
        <input type="text" [(ngModel)]="searchTerm" placeholder="Search..." (click)="$event.stopPropagation()" />
        <div class="options-list">
            <div *ngFor="let opt of filteredOptions" class="form-check">
                <input type="checkbox" class="form-check-input" [id]="'check-' + opt.id" [checked]="isSelected(opt)" (change)="toggleSelection(opt)" />
                <label class="form-check-label" [for]="'check-' + opt.id">
                    {{ opt.name }}
                </label>
            </div>
        </div>
    </div>
</div>